const WORDS = Array.from({ length: 140 });

const DOTS = [
  [6, 12], [18, 6], [30, 18], [44, 9], [58, 16], [72, 7], [86, 14], [95, 26],
  [10, 34], [24, 42], [38, 32], [52, 40], [66, 30], [80, 38], [92, 48],
  [4, 58], [16, 66], [32, 60], [48, 70], [62, 58], [76, 68], [90, 72],
  [12, 86], [28, 80], [42, 92], [56, 84], [70, 94], [84, 86], [96, 92],
];
const LINKS = DOTS.flatMap((a, i) =>
  DOTS.slice(i + 1)
    .filter((b) => Math.hypot(a[0] - b[0], a[1] - b[1]) < 17)
    .map((b) => [a, b]),
);

export const Watermark = () => (
  <>
    <svg className="network" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
      {LINKS.map(([a, b], i) => (
        <line key={i} x1={a[0]} y1={a[1]} x2={b[0]} y2={b[1]} stroke="rgba(245,197,66,0.10)" strokeWidth="0.08" />
      ))}
      {DOTS.map(([x, y], i) => (
        <circle
          key={i}
          className="dot"
          cx={x}
          cy={y}
          r="0.28"
          fill={i % 3 === 0 ? "#ff3b45" : "#f5c542"}
          style={{ animationDelay: `${(i % 7) * 0.6}s` }}
        />
      ))}
    </svg>
    <div className="watermark" aria-hidden="true" data-testid="brand-watermark">
      <div className="watermark-grid">
        {WORDS.map((_, i) => (
          <span key={i}>FAB-MIND-OS</span>
        ))}
      </div>
    </div>
  </>
);
